export const ONE_MINUTE = 60000;
export const TWO_MINUTES = 2 * ONE_MINUTE;
export const ONE_MINUTE_IN_SECONDS = 60;
export const ONE_HOUR = 60 * 60 * 1000;

export const toMilliseconds = (seconds: number) => {
  return seconds * 1000;
};
